import React from 'react';

import AccountIcon from '@mui/icons-material/AccountCircle';
import {
  IconButton,
  Drawer,
  List,
  Tooltip,
  ListItem,
  ListItemText,
} from '@mui/material';
import { useSelector } from 'react-redux';

import * as selectorsUser from '../selector';

import AboutItem from './AboutItem';
import EditEmailDialog from './EditEmailDialog';
import EditEmailItem from './EditEmailItem';
import SignoutItem from './SignoutItem';

import { version } from '@/constants/env';

/** プロパティ */
export type Props = {
  /** 無効か */
  disabled: boolean,
}

const Account: React.FC<Props> = ({ disabled }) => {
  const user = useSelector(selectorsUser.userSelector);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenEditEmailDialog, setIsOpenEditEmailDialog] = React.useState(false);
  return (
    <div>
      <Tooltip title="アカウント情報">
        <span>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="Menu"
            onClick={() => setIsOpen(true)}
            disabled={disabled}
          >
            <AccountIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div style={{ width: '250px' }}>
          <List>
            <ListItem>
              <ListItemText secondary={`${user?.name}さん`} />
            </ListItem>
            <SignoutItem onClick={() => setIsOpen(false)} />
            <EditEmailItem onClick={() => setIsOpenEditEmailDialog(true)} />
            <AboutItem />
            <ListItem sx={{ justifyContent: 'flex-end' }}>
              <ListItemText
                secondary={`Ver ${version}`}
                secondaryTypographyProps={{ align: 'right' }}
                sx={{ textAlign: 'right' }}
              />
            </ListItem>
          </List>
        </div>
        <EditEmailDialog
          isOpen={isOpenEditEmailDialog}
          close={() => {
            setIsOpenEditEmailDialog(false);
            setIsOpen(false);
          }}
        />
      </Drawer>
    </div>
  );
};

export default Account;
